import TabItem from '../@types/tab-item';
import {getFromLocalStorage, setToLocalStorage} from './local-storage-utils';
import {makeGroup} from './group-utils';

const TAB_ITEMS = 'TabItems';
const TAB_INDEX = 'TabIndex';

export function getTabItems(): TabItem[] {
    const items = getFromLocalStorage(TAB_ITEMS) ?? [];
    items.forEach((item: any) => {
        if (item.objectToEdit && item.objectToEdit.group) {
            item.objectToEdit.group = makeGroup(item.objectToEdit.group);
        }
    });
    return items;
}

const HEAVY_KEYS: readonly string[] = [
    'safetyModel',
    'faultTree',
    'faultTreeNodes',
    'events',
    'eventSequences',
];

function sanitizeTabsForStorage(tabs: TabItem[]): TabItem[] {
    return tabs.map((tab) => {
        if (!tab.objectToEdit) {
            return tab;
        }

        const needsStripping = HEAVY_KEYS.some(
            (key) => tab.objectToEdit[key] != null,
        );
        if (!needsStripping) {
            return tab;
        }

        const sanitized: Record<string, unknown> = { ...tab.objectToEdit };
        for (const key of HEAVY_KEYS) {
            delete sanitized[key];
        }

        // Safe cast: only used for JSON serialization where compareTo is irrelevant
        return { ...tab, objectToEdit: sanitized } as TabItem;
    });
}

export function updateTabItems(tabs: TabItem[]): void {
    setToLocalStorage(TAB_ITEMS, sanitizeTabsForStorage(tabs));
}

export function getCurrentTabIndex (): number {
    return getFromLocalStorage(TAB_INDEX) != null ? parseInt(getFromLocalStorage(TAB_INDEX) as string) : 0;
}

export function updateCurrentTabIndex(index: number): void {
    setToLocalStorage(TAB_INDEX, index.toString());
}
